// =============================================================================
// sessionMacroResolution — pure utilities for resolving impression macros
// (TTD/CENTRO/LiquidM ad-server detection, OS classification from
// user-agent strings).
//
// Logic preserved verbatim from the legacy `SessionJourneyExpand.js`
// implementation. Extracted into its own file so the React component can
// stay focused on rendering and so future test coverage can target the
// pure transforms without React mounting.
// =============================================================================

export const getMobileOperatingSystem = (userAgent) => {
  if (!userAgent) return 'Unknown';
  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) return 'Windows Phone';
  if (/android/i.test(userAgent)) return 'Android';
  if (/iPad/.test(userAgent) && !window.MSStream) return 'iPad';
  if (/iPhone/.test(userAgent) && !window.MSStream) return 'iPhone';
  if (/iPod/.test(userAgent) && !window.MSStream) return 'iPod';
  if (/CrOS/.test(userAgent) && !window.MSStream) return 'Chromebook Computer';
  if (/Macintosh/.test(userAgent)) return 'Apple Computer';
  if (/Windows NT/.test(userAgent)) return 'Windows Computer';
  return 'Computer';
};

export const determineAdServer = (url) => {
  if (!url) return 'Unknown';

  if (
    url.includes('amazon-adsystem') ||
    url.includes('mopub') ||
    url.includes('adsbynimbus') ||
    url.includes('smartadserver') ||
    url.includes('localhost') ||
    url.includes('googlesyndication') ||
    url.includes('doubleclick') ||
    url.includes('inner-active.mobi') ||
    url.includes('nexage') ||
    url.includes('adcolony') ||
    url.includes('sdk')
  )
    return 'Ad Server';

  if (url.includes('itunes') || url.includes('play.google') || url.includes('apps.apple.com'))
    return 'Application';

  // Encoded / obfuscated ad server URL signatures — long subdomains or
  // long alphanumeric runs.
  const suspiciousPatterns = [/^[a-zA-Z0-9]{30,}\./, /^r\d+\./, /[0-9a-z]{40,}/];
  for (const pattern of suspiciousPatterns) {
    if (pattern.test(url)) return 'Ad Server';
  }

  return 'Website';
};
